export { default as copyToClipboard } from './copyToClipboard';
